// extracted by mini-css-extract-plugin
export default {"content":"detail_content__eHFGF"};